import React, { useEffect, useState } from 'react'
import {
  Typography,
  Table,
  Avatar,
  Button,
  Form,
  Modal,
  Input,
  Switch
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  PlusOutlined,
  UserOutlined,
  MailOutlined,
  MobileOutlined
} from '@ant-design/icons'
import Spinner from '../../components/Spinner'
import { DateTime } from 'luxon'
import { FlexSectionHeader } from '../style'
import { register } from '../../reducers/authReducer'
import {
  getAllInstructors,
  toggleUserStatus
} from '../../reducers/participantsReducer'

const { Title, Text } = Typography
const { Column } = Table

const Instructors = () => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [modalVisible, setModalVisible] = useState(false)

  const participants = useSelector((state) => state.courseParticipants.data)
  const loading = useSelector((state) => state.courseParticipants.loading)

  useEffect(() => {
    dispatch(getAllInstructors())
  }, [])

  const handleCancel = () => {
    setModalVisible(false)
  }

  const addInstructor = async (values) => {
    try {
      const payload = { ...values, role: 'instructor' }
      const res = dispatch(register(payload))
      if (res) {
        dispatch(getAllInstructors())
        setModalVisible(false)
        form.resetFields()
      }
    } catch (err) {
      console.error('Create instructor failed:', err)
    }
  }

  if (loading) return <Spinner size="large" />

  return (
    <>
      <FlexSectionHeader>
        <Title level={3}>All Instructors</Title>
        <Button
          onClick={() => setModalVisible(true)}
          type="dashed"
          shape="round"
          style={{ height: '40px' }}
          icon={<PlusOutlined />}
        >
          Add Instructor
        </Button>
      </FlexSectionHeader>

      <Modal
        title="Add New Instructor"
        visible={modalVisible}
        onOk={form.submit}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={form.submit}>
            Submit
          </Button>
        ]}
      >
        <Form
          name="add Instructor"
          form={form}
          onFinish={addInstructor}
          requiredMark={false}
          layout="vertical"
        >
          <Form.Item
            name="name"
            rules={[
              { required: true, message: 'Please enter your fullname' },
              { min: 3, message: 'Fullname must contain at least 3 characters' }
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Enter full name" />
          </Form.Item>

          <Form.Item
            name="username"
            rules={[
              { required: true, message: 'Please enter your username' },
              { min: 3, message: 'Username must contain at least 3 characters' }
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Enter username" />
          </Form.Item>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please enter your email' },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@spanidea\.com$/,
                message: 'Please enter a valid spanidea email'
              }
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Enter email" />
          </Form.Item>

          <Form.Item
            name="mobile"
            rules={[
              { required: true, message: 'Please enter your mobile number' },
              {
                pattern: /^[0-9]{10}$/,
                message: 'Mobile number must be 10 digits'
              }
            ]}
          >
            <Input
              prefix={<MobileOutlined />}
              placeholder="Enter mobile number"
              maxLength={10}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) e.preventDefault()
              }}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Table
        pagination={false}
        style={{ marginTop: '24px' }}
        rowKey={(participant) => participant._id}
        dataSource={participants}
      >
        <Column
          title="Photo"
          dataIndex="photo"
          render={(img) => <Avatar src={img} />}
        />
        <Column title="Name" dataIndex="name" />
        <Column title="Email" dataIndex="email" />
        <Column
          title="Mobile Number"
          dataIndex="mobile"
        />
        <Column
          title="Status"
          dataIndex="isActive"
          render={(isActive, record) => (
            <Switch
              checked={isActive}
              onChange={() => dispatch(toggleUserStatus(record._id))}
            />
          )}
        />
      </Table>
    </>
  )
}

export default Instructors
